import { render, staticRenderFns } from "./Commission_Item.vue?vue&type=template&id=14859228&scoped=true&"
import script from "./Commission_Item.vue?vue&type=script&lang=js&"
export * from "./Commission_Item.vue?vue&type=script&lang=js&"
import style0 from "./Commission_Item.vue?vue&type=style&index=0&id=14859228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14859228",
  null
  
)

export default component.exports